// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2APfD","buttons":"Footer_buttons__2euE1"};